import { History } from "history";

import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_USER_SUCCESS,
  RESET_LOGIN_FLAG,
  LOGIN_ERROR,
  FORGET_PASSWORD,
  FORGET_PASSWORD_ERROR,
  FORGET_PASSWORD_SUCCESS,
  LoginAction,
  LoginSuccessAction,
  LoginErrorAction,
  LogoutAction,
  LogoutSuccessAction,
  ForgetPasswordSuccessAction,
  ForgetPasswordAction,
  ForgetPasswordErrorAction,
  VerifyOTPAction,
  VerifyOTPSuccessAction,
  VERIFY_OTP,
  VERIFY_OTP_SUCCESS,
  VerifyOTPErrorAction,
  VERIFY_OTP_ERROR,
  RESEND_OTP,
  RESEND_OTP_SUCCESS,
  ResendOTPAction,
  ResendOTPSuccessAction,
  ResendOTPErrorAction,
  RESEND_OTP_ERROR,
  ResetPasswordAction,
  ResetPasswordSuccessAction,
  ResetPasswordErrorAction,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
} from "./actionTypes";
import {
  CreateVerificationRequest,
  CreateVerificationResponse,
  ForgetPasswordRequest,
  ResetPasswordRequest,
  SigninRequest,
  SigninResponse,
  SignoutRequest,
  VerificationRequest,
  VerificationResponse,
} from "../../interfaces";

//#region login

export const login = (
  request: SigninRequest,
  history: History
): LoginAction => {
  return {
    type: LOGIN,
    payload: { request, history },
  };
};

export const loginSuccess = (response: SigninResponse): LoginSuccessAction => {
  return {
    type: LOGIN_SUCCESS,
    payload: response,
  };
};

export const loginError = (error: any): LoginErrorAction => {
  return {
    type: LOGIN_ERROR,
    payload: error,
  };
};

export const resetLoginFlag = () => {
  return {
    type: RESET_LOGIN_FLAG,
  };
};

//#endregion

//#region logout
export const logout = (request: SignoutRequest, history: any): LogoutAction => {
  return {
    type: LOGOUT,
    payload: { request, history },
  };
};

export const logoutSuccess = (): LogoutSuccessAction => {
  return {
    type: LOGOUT_USER_SUCCESS,
  };
};

//#endregion

//#region forget-password
export const forgetPassword = (
  request: ForgetPasswordRequest,
  history: History
): ForgetPasswordAction => {
  return {
    type: FORGET_PASSWORD,
    payload: { request, history },
  };
};

export const forgetPasswordSuccess = (
  response: VerificationResponse
): ForgetPasswordSuccessAction => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: response,
  };
};

export const forgetPasswordError = (error: any): ForgetPasswordErrorAction => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: error,
  };
};

//#endregion

//#region forget-password
export const verifyOTP = (
  request: VerificationRequest,
  history: History
): VerifyOTPAction => {
  return {
    type: VERIFY_OTP,
    payload: { request, history },
  };
};

export const verifyOTPSuccess = (
  response: SigninResponse
): VerifyOTPSuccessAction => {
  return {
    type: VERIFY_OTP_SUCCESS,
    payload: response,
  };
};

export const verifyOTPError = (error: any): VerifyOTPErrorAction => {
  return {
    type: VERIFY_OTP_ERROR,
    payload: error,
  };
};

//#endregion

//#region forget-password
export const resendOTP = (
  request: CreateVerificationRequest,
  history: History
): ResendOTPAction => {
  return {
    type: RESEND_OTP,
    payload: { request, history },
  };
};

export const resendOTPSuccess = (
  response: CreateVerificationResponse
): ResendOTPSuccessAction => {
  return {
    type: RESEND_OTP_SUCCESS,
    payload: response,
  };
};

export const resendOTPError = (error: any): ResendOTPErrorAction => {
  return {
    type: RESEND_OTP_ERROR,
    payload: error,
  };
};

//#endregion

//#region reset-password
export const resetPassword = (
  request: ResetPasswordRequest,
  history: History
): ResetPasswordAction => {
  return {
    type: RESET_PASSWORD,
    payload: { request, history },
  };
};

export const resetPasswordSuccess = (
  response: boolean
): ResetPasswordSuccessAction => {
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload: response,
  };
};

export const resetPasswordError = (error: any): ResetPasswordErrorAction => {
  return {
    type: RESET_PASSWORD_ERROR,
    payload: error,
  };
};

//#endregion
